var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"text"},on:{"click":_vm.jump}},[_vm._v(_vm._s(_vm.scope.row[_vm.tableData.bind]))])
}
var staticRenderFns = []

export { render, staticRenderFns }